import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00148eee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "condition-block" }
const _hoisted_2 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Conditions = _resolveComponent("Conditions")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Conditions, {
        conditions: _ctx.conditions,
        "product-type-option-list": _ctx.productTypeOptionList,
        "brand-list-option": _ctx.brandListOption
      }, null, 8, ["conditions", "product-type-option-list", "brand-list-option"]),
      _createVNode(_component_BaseButton, {
        variant: "outline-primary",
        title: "Add item",
        onClick: _ctx.addElement
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Добавить условие ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}